import * as actions from './channel.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ChatChannelModel } from '@smarttask-common/src/lib/models/Chat/Channel/ChatChannelModel';

export const channelAdapter = createEntityAdapter<ChatChannelModel>({
    selectId: (x) => x.channel_id,
});
export interface ChatChannelState extends EntityState<ChatChannelModel> {
    selected_channel_id: string;
}

export const initialState: ChatChannelState = channelAdapter.getInitialState({
    selected_channel_id: undefined,
});

export function ChatChannelReducers(state: ChatChannelState = initialState, action: actions.ChatChannelActions) {
    switch (action.type) {
        case actions.ChatChannelActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_channel_id: action.selected_channel_id };
            //console.log(state);
            return state;

        case actions.ChatChannelActionTypes.ADD_CHATCHANNEL:
            return channelAdapter.addOne(action.channel, state);

        case actions.ChatChannelActionTypes.ADD_CHATCHANNELS:
            return channelAdapter.addMany(action.channels, state);

        case actions.ChatChannelActionTypes.UPSERT_CHATCHANNEL:
            return channelAdapter.upsertOne(action.channel, state);

        case actions.ChatChannelActionTypes.UPSERT_CHATCHANNELS:
            return channelAdapter.upsertMany(action.channels, state);

        case actions.ChatChannelActionTypes.UPDATE_CHATCHANNEL:
            return channelAdapter.updateOne(action.channel, state);

        case actions.ChatChannelActionTypes.UPDATE_CHATCHANNELS:
            return channelAdapter.updateMany(action.channels, state);

        case actions.ChatChannelActionTypes.DELETE_CHATCHANNEL:
            // if(state.selectedChatChannelId == action.id){
            //   state.selectedChatChannelId = undefined;
            // }
            return channelAdapter.removeOne(action.id, state);

        case actions.ChatChannelActionTypes.DELETE_CHATCHANNELS:
            // if(action.ids.indexOf(state.selectedChatChannelId) > -1){
            //   state.selectedChatChannelId = undefined;
            // }
            return channelAdapter.removeMany(action.ids, state);

        case actions.ChatChannelActionTypes.DELETE_ALL_CHATCHANNELS:
            return channelAdapter.removeMany(action.ids, state);

        case actions.ChatChannelActionTypes.DELETE_ALL:
            return channelAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getChatChannelState = createFeatureSelector<ChatChannelState>('chatChannel');

export const { selectIds, selectEntities, selectAll, selectTotal } = channelAdapter.getSelectors(getChatChannelState);

const getSelectedChatChannelIdState = (state: ChatChannelState) => {
    return state.selected_channel_id;
};
export const getSelectedChatChannelId = createSelector(getChatChannelState, getSelectedChatChannelIdState);

export const getSelectedChatChannel = createSelector(getChatChannelState, (state: ChatChannelState) => {
    if (state.selected_channel_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_channel_id];
});
